<template>
  <div class="main-body">
    <div class="header">服务人员订单</div>
    <div class="out">

      <div class="search2">

        <el-button plain type="success" @click="onBatchExport" size="mini">导出</el-button>

        <div style="float: right">

          <elSelectTree :options='zoneValue' accordion :props="zoneProps" v-if="zoneValue.length>0"
                        placeholder="所属区域" v-on:getZoneValue="getZoneValue"
                        v-on:getZoneTitle="getZoneTitle" :value='zoneCode'
                        style="width:150px;margin-right:5px"></elSelectTree>

<!--          <el-select size="mini" v-model="businessCode" placeholder="请选择商家"-->
<!--                     @change="bus_change"-->
<!--                     style="width:150px;margin-right:5px">-->
<!--            <el-option-->
<!--                v-for="item in arr_business"-->
<!--                :key="item.businessCode"-->
<!--                :label="item.businessName"-->
<!--                :value="item.businessCode">-->
<!--            </el-option>-->
<!--          </el-select>-->

          <el-select size="mini" v-model="serveCode" clearable placeholder="请选择服务人员"
                     style="width:150px;margin-right:5px">
            <el-option
                v-for="item in arr_serve"
                :key="item.serveCode"
                :label="item.name"
                :value="item.serveCode">
            </el-option>
          </el-select>

          <el-date-picker style="margin-right: 5px;width:210px;" title="起止时间" size="mini"
                          v-model="startEndTime"
                          type="daterange"
                          value-format="yyyy-MM-dd"
                          format="yyyy-MM-dd"
                          :clearable="false"
                          range-separator="至"
                          start-placeholder="开始时间"
                          end-placeholder="结束时间">
          </el-date-picker>

          <el-button size="mini" type="primary" @click="getList">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" :height="th"
                v-loading="loading" ref="table"
                border style="width: 100%;">

        <el-table-column prop="serialNumber" label="订单流水号" width="130" fixed></el-table-column>

<!--        <el-table-column prop="businessName" label="商家" width="105"></el-table-column>-->
        <el-table-column prop="serveName" label="服务人员" width="105"></el-table-column>

        <el-table-column prop="userName" label="老人姓名" width="85"></el-table-column>

        <el-table-column prop="" label="服务项目" width="150">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.listOrderGoodsDTO" :key="index">
              <div>{{item.goodsName}}</div>
            </div>
          </template>
        </el-table-column>

<!--        <el-table-column prop="" label="单价" width="105">-->
<!--          <template slot-scope="scope">-->
<!--            <div v-for="(item,index) in scope.row.listOrderGoodsDTO" :key="index">-->
<!--              <div>{{item.goodsPrice}}</div>-->
<!--            </div>-->
<!--          </template>-->
<!--        </el-table-column>-->

        <el-table-column prop="" width="105" label="数量">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.listOrderGoodsDTO" :key="index">
              <div>{{item.number}}</div>
            </div>
          </template>
        </el-table-column>


<!--        <el-table-column prop="price" label="总价" width="105"></el-table-column>-->

<!--        <el-table-column width="105" label="订单来源" >-->
<!--          <template slot-scope="scope">-->
<!--            <div v-if="scope.row.orderFrom =='business'">商家预工单</div>-->
<!--            <div v-if="scope.row.orderFrom =='android' ">长者端</div>-->
<!--            <div v-if="scope.row.orderFrom =='table' ">收银机</div>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column width="105" label="订单类型" >-->
<!--          <template slot-scope="scope">-->
<!--            <div v-if="scope.row.orderType ==2 ">单独服务</div>-->
<!--            <div v-if="scope.row.orderType ==3 ">合并服务</div>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="付款类型" >-->
<!--          <template slot-scope="scope">-->
<!--            <div v-if="scope.row.payType == 'wx' ">微信</div>-->
<!--            <div v-if="scope.row.payType == 'ali' ">支付宝</div>-->
<!--            <div v-if="scope.row.payType == 'yue' ">余额</div>-->
<!--            <div v-if="scope.row.payType == 'cash' ">现金</div>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column width="105" label="订单状态">
          <template slot-scope="scope">
            <div v-if="scope.row.status =='10' ">待付款</div>
            <div v-if="scope.row.status =='11' ">待接单</div>
            <div v-if="scope.row.status =='12' ">待开始</div>
            <div v-if="scope.row.status =='13' ">待结束</div>
            <div v-if="scope.row.status =='14' ">待评价</div>
            <div v-if="scope.row.status =='15' ">已取消</div>
            <div v-if="scope.row.status =='16' ">已评价</div>
          </template>
        </el-table-column>

        <!--        <el-table-column prop="createTime" :formatter="timefilter" width="200" label="下单时间"></el-table-column>-->
        <!--        <el-table-column prop="payTime" :formatter="timefilter" width="200" label="付款时间"></el-table-column>-->
        <!--        <el-table-column prop="planTime" :formatter="timefilter" width="200" label="预约时间"></el-table-column>-->

        <el-table-column prop="createTime" :formatter="timefilter" width="120" label="创建时间"></el-table-column>
        <el-table-column prop="planTime" :formatter="timefilter" width="120" label="预约服务时间"></el-table-column>
        <el-table-column prop="startTime" :formatter="timefilter" width="120" label="开始服务时间"></el-table-column>
        <el-table-column prop="completeTime" :formatter="timefilter" width="120" label="完成服务时间"></el-table-column>



        <el-table-column prop="completeTime" width="200" label="服务时长">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="showEdit(scope.row)">{{timeLong(scope.row,null,scope.row.completeTime)}}</el-button>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="120" >
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="showInfo(scope.row)">详情</el-button>

            <el-button v-if="scope.row.status==14 || scope.row.status==16" type="text" size="mini"
                       @click="refund(scope.row)">退单</el-button>

          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{ totalItems }}条（{{ Math.ceil(totalItems / pageSize) }}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>


    <Info ref="myInfo" v-show="showModalInfo" v-on:closeInfo="showModalInfo=false"></Info>

    <div v-if="showModal" class="mask">
      <div class="lodingsIcon">
        <i class="el-icon-loading"></i><span>正在处理，请等待。。。</span>
      </div>
    </div>

    <ServeOrderEdit ref="myServeOrderEdit" v-show="showModalEdit" v-on:closeEdit="showModalEdit=false" v-on:getList="getList"></ServeOrderEdit>



  </div>
</template>

<script>
import {timeStr, timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


import elSelectTree from "@/components/ElSelectTree";
import Info from "./Info3";
import ServeOrderEdit from "./ServeOrderEdit";

import table2excel from "js-table2excel";

export default {
  name: "Page",
  data() {
    return {

      showModal:false,
      showModalInfo:false,
      showModalEdit:false,

      showModalSelectElderly: false,
      showModalSelectServe: false,

      serveOrderPrice:0,

      loading: false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      startEndTime:[],
      userCode:'',

      imgUrl: this.$imgUrl,
      th: this.$store.state.tableHeight,



      arr_business:[],
      businessCode:'',

      arr_serve:[],
      serveCode:'',


      zoneValue: [],
      zoneCode: '',
      zoneTitle:'',
      zoneProps: {
        emitPath: false,
        value: 'zoneCode',
        label: 'name',
        children: 'listZoneDTO'
      },


    }
  },
  components: {
    Info,elSelectTree,ServeOrderEdit
  },
  created() {
    this.init();
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
      this.$nextTick(()=>{
        this.$refs.table.doLayout()
      })
    },
  },
  methods: {

    init() {

      const now = new Date();
      const start = new Date(now - 1000 * 60 * 60 * 24 * 30);
      const end = new Date(now);
      this.startEndTime = [timefilters(start).substring(0,10), timefilters(end).substring(0,10)];

      this.getBusiness();
      this.getZoneList();

    },


    showInfo(row){
      this.showModalInfo = !this.showModalInfo;
      this.$refs.myInfo.init(row.orderBusinessCode);
    },

    getZoneValue(val) {
      this.zoneCode = val
    },
    getZoneTitle(val) {
      this.zoneTitle = val
    },
    getZoneList:function (){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Zone/ListForStaff",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              var data = JSON.stringify(response.data.data);
              data = JSON.parse(data.replace(/"listZoneDTO":\[\],/g, ''))
              this.zoneValue = data;
              //this.zoneCode=data[0].zoneCode;

            } else if (response.data.error == 1) {
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },

    getBusiness(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Business/ListForGov",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {
        if (response.data.error === 0) {

          this.arr_business = [];
          let arr = response.data.data;
          for(let i=0;i<arr.length;i++){
            if(arr[i].businessType == 6){
              this.arr_business.push(arr[i]);
            }
          }

          if(this.arr_business.length>0){
            this.businessCode = this.arr_business[0].businessCode;
            this.getList();
            this.getServe(this.businessCode);
          }

        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }
      })
    },

    bus_change(val){
      this.serveCode='';
      this.getServe(val);
    },
    getServe(businessCode){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Serve/ListServe",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          businessCode: businessCode,
        }
      }).then((response) => {
        if (response.data.error === 0) {
          this.arr_serve = response.data.data;

        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }
      })
    },


    timefilter(row, column, cellValue) {
      if (cellValue) {
        return timefilters(cellValue)
      }
    },
    timeLong(row, column, cellValue) {
      if (cellValue) {
        let rv = "";
        if(row.status==14 || row.status==16){

          let pt = row.startTime;
          let et = row.completeTime;


          //var d1 = new Date('2016/03/28 10:17:22');
          var d1 = new Date(timefilters(pt));
          var d2 = new Date(timefilters(et));

          //console.log(parseInt(d2 - d1));//两个时间相差的毫秒数
          //console.log(parseInt(d2 - d1) / 1000);//两个时间相差的秒数
          //console.log(parseInt(d2 - d1) / 1000 / 60);//两个时间相差的分钟数
          //console.log(parseInt(d2 - d1) / 1000 / 60 / 60);//两个时间相差的小时数

          let fen = parseInt(d2 - d1) / 1000 / 60;

          let f1 = parseInt(fen,10);

          let h1 = Math.floor(f1/60);
          let y1 = f1%60;

          rv = h1+"小时"+y1+"分";

        }
        return rv;
      }
    },


    getSummaries(param) {

      //const { columns, data } = param;console.log(data);
      const { columns} = param;
      const sums = [];
      columns.forEach((column, index) => {

        if (index === 0) {
          sums[index] = '合计';
        }

        if (index == 7) {
          sums[index] = parseFloat(this.serveOrderPrice).toFixed(2);
        }


        // const values = data.map(item => Number(item[column.property]));
        // if (!values.every(value => isNaN(value))) {
        //     sums[index] = values.reduce((prev, curr) => {
        //         const value = Number(curr);
        //         if (!isNaN(value)) {
        //             return prev + curr;
        //         } else {
        //             return prev;
        //         }
        //     }, 0);
        //     sums[index] += ' 元';
        // } else {
        //     sums[index] = 'N/A';
        // }



      });

      return sums;
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    getList(isSearch) {

      if(isSearch)this.currentPage=1

      var _this=this
      this.loading=true

      let data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        staffCode: getStaffCode(),

        pageIndex:this.currentPage,
        pageSize:this.pageSize,

        startTime:this.startEndTime[0],
        endTime:this.startEndTime[1],

        businessCode:this.businessCode,
        serveCode:this.serveCode,
        isDelete:-1,
        status:-1,
        userCode:this.userCode,
        zoneCode:this.zoneCode,

      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "OrderBusinessGov/PageServe",
        data: data
      }).then((response) => {

        this.loading = false;

        if (response.data.error === 0) {
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
          this.serveOrderPrice=response.data.data.allPrice;

          this.$nextTick(()=>{
            this.$refs.table.doLayout()
          })

        } else if (response.data.error === 1) {
          this.$message.error(response.data.message)
        }

      }).catch(function (error) {
        _this.loading = false;
        console.log(error);
      });

    },



    refund(row){

      this.$confirm('确认退单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.$axios({
          method: 'post',
          url: this.$shopUrl + "OrderBusinessAdm/AdmRefund",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),
            orderBusinessCode:row.orderBusinessCode,
          }
        }).then((response) => {
          if (response.data.error == 0) {
            this.getList()
            this.$message({type: 'success', message: '退单成功'});
          } else if (response.data.error == 1) {
            this.$message({type: 'error', message: response.data.message});
          }
        }).catch(function (error) {
          console.log(error);
        });

      }).catch(() => {

      });

    },

    onBatchExport() {

      this.showModal=true

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"OrderBusinessGov/PageServeMul",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:1,
          pageSize:9999,

          startTime:this.startEndTime[0],
          endTime:this.startEndTime[1],

          businessCode:this.businessCode,
          serveCode:this.serveCode,

          zoneCode:this.zoneCode,
          userCode:this.userCode,
          isDelete:-1,
          status:-1,

        }
      }).then( (response)=> {
        this.showModal=false

        if(response.data.error == 0){
          let list = response.data.data.pageInfo.list;

          let dd = [];
          for(let i=0;i<list.length;i++){
            let obj = {};
            obj["serialNumber"] = list[i].serialNumber+'-';
            obj["businessName"] = list[i].businessName;
            obj["serveName"] = list[i].serveName;
            obj["userName"] = list[i].userName;

            let goodsDTO = list[i].listOrderGoodsDTO;
            let str = "";
            let str2 = "";
            let str3 = "";
            for(let j=0;j<goodsDTO.length;j++){
              str += '<div>'+goodsDTO[j].goodsName+'</div>';
              str2 += '<div>'+goodsDTO[j].goodsPrice+'</div>';
              str3 += '<div>'+goodsDTO[j].number+'</div>';
            }
            obj["goodsName"] = str;
            obj["goodsPrice"] = str2;
            obj["goodsNumber"] = str3;

            obj["price"] = list[i].price;

            let orderType = "";
            if(list[i].orderType == 2){
              orderType = "单独服务";
            }
            if(list[i].orderType == 3){
              orderType = "合并服务";
            }
            obj["orderType"] = orderType;

            let payType = "";
            if(list[i].payType == 'cash'){
              payType = "现金";
            }
            if(list[i].payType == 'yue'){
              payType = "余额";
            }
            if(list[i].payType == 'wx'){
              payType = "微信";
            }
            if(list[i].payType == 'ali'){
              payType = "支付宝";
            }
            obj["payType"] = payType;

            let status = "";
            if(list[i].status == 10){
              status = "待付款";
            }
            if(list[i].status == 11){
              status = "待接单";
            }
            if(list[i].status == 12){
              status = "待服务";
            }
            if(list[i].status == 13){
              status = "待结束";
            }
            if(list[i].status == 14){
              status = "待评价";
            }
            if(list[i].status == 15){
              status = "已取消";
            }
            if(list[i].status == 16){
              status = "已评价";
            }
            if(list[i].status == 17){
              status = "已退单";
            }
            obj["status"] = status;


            obj["createTime"] = timefilters(list[i].createTime);
            obj["payTime"] = timefilters(list[i].payTime);
            obj["planTime"] = timefilters(list[i].planTime);
            obj["completeTime"] = timefilters(list[i].completeTime);
            obj["startTime"] = timefilters(list[i].startTime);


            let start = list[i].orderServeRecordDTOStart;
            if(start != null){
              let arr_start = start.listOrderServeRecordImg;
              if(arr_start.length==1){
                obj["start_img1"] = this.imgUrl+arr_start[0].imgPath+'_watermark.jpg';
                obj["start_img2"] = '';
              }
              if(arr_start.length==2){
                obj["start_img1"] = this.imgUrl+arr_start[0].imgPath+'_watermark.jpg';
                obj["start_img2"] = this.imgUrl+arr_start[1].imgPath+'_watermark.jpg';
              }
            }else{
              obj["start_img1"] = '';
              obj["start_img2"] = '';
            }

            let end = list[i].orderServeRecordDTOEnd;
            if(end != null){
              let arr_end = end.listOrderServeRecordImg;
              if(arr_end.length==1){
                obj["end_img1"] = this.imgUrl+arr_end[0].imgPath+'_watermark.jpg';
                obj["end_img2"] = '';
              }
              if(arr_end.length==2){
                obj["end_img1"] = this.imgUrl+arr_end[0].imgPath+'_watermark.jpg';
                obj["end_img2"] = this.imgUrl+arr_end[1].imgPath+'_watermark.jpg';
              }
            }else{
              obj["end_img1"] = '';
              obj["end_img2"] = '';
            }


            dd.push(obj);
          }


          const column = [
            {
              title: '订单号',
              key: 'serialNumber',
              type: 'text'
            },{
              title: '商家',
              key: 'businessName',
              type: 'text'
            },
            {
              title: '服务人员',
              key: 'serveName',
              type: 'text'
            },
            {
              title: '老人',
              key: 'userName',
              type: 'text'
            },
            {
              title: '服务项目',
              key: 'goodsName',
              type: 'text'
            },
            {
              title: '单价',
              key: 'goodsPrice',
              type: 'text'
            },
            {
              title: '数量',
              key: 'goodsNumber',
              type: 'text'
            },
            {
              title: '总价',
              key: 'price',
              type: 'text'
            },
            {
              title: '订单类型',
              key: 'orderType',
              type: 'text'
            },
            // {
            //   title: '支付类型',
            //   key: 'payType',
            //   type: 'text'
            // },
            {
              title: '订单状态',
              key: 'status',
              type: 'text'
            },

            // {
            //   title: '下单时间',
            //   key: 'createTime',
            //   type: 'text'
            // },
            // {
            //   title: '付款时间',
            //   key: 'payTime',
            //   type: 'text'
            // },
            {
              title: '开始时间',
              key: 'startTime',
              type: 'text'
            },
            {
              title: '完成时间',
              key: 'completeTime',
              type: 'text'
            },


            //图片高度超过20会出现异常
            {
              title: '服务开始照片1',
              key: 'start_img1',
              type: 'image',
              width: 50,
              height: 20
            },
            {
              title: '服务开始照片2',
              key: 'start_img2',
              type: 'image',
              width: 50,
              height: 20
            },
            {
              title: '服务结束照片1',
              key: 'end_img1',
              type: 'image',
              width: 50,
              height: 20
            },
            {
              title: '服务结束照片2',
              key: 'end_img2',
              type: 'image',
              width: 50,
              height: 20
            },


          ]
          table2excel(column, dd, '服务人员订单'+'['+this.zoneTitle+']');

        }
      }).catch(function (error) {
        console.log(error);
      });


    },

    showEdit(row){
      this.showModalEdit = !this.showModalEdit;
      this.$refs.myServeOrderEdit.init(row);
    },

  }
}
</script>


<style lang="scss" scoped>


</style>
